type BoxmapType = 'BOOKING' | 'BLABLACAR';

export interface PartnerBoxMapData {
	type: BoxmapType;
	message: string;
	url: string;
	img: string;
	shortMessage?: string;
	tracking?: string;
}

export const getBoxmapsOrder = (): BoxmapType[] => ['BOOKING', 'BLABLACAR'];

export { getBlablacarBoxMapData } from './blablacar';
